import type { RefObject } from 'react';
import { MessageTypes } from '../constants';
import type { Messageable } from '../handleGraphQLMessage';
import {
  handleGraphQLMessage,
  handleGraphQLSubscription,
  unsubscribeGraphQLSubscription,
} from '../handleGraphQLMessage';

export const mockEventHandler = (
  event: MessageEvent,
  windowRef: RefObject<UXPWebviewElement | Window | Messageable>
) => {
  const messageEvent = event;

  if (messageEvent.data.type === MessageTypes.GRAPHQL_REQUEST) {
    handleGraphQLMessage(messageEvent, windowRef.current);
  }

  if (messageEvent.data.type === MessageTypes.GRAPHQL_SUBSCRIBE) {
    handleGraphQLSubscription(messageEvent, windowRef.current);
  }
  if (messageEvent.data.type === MessageTypes.GRAPHQL_UNSUBSCRIBE) {
    unsubscribeGraphQLSubscription(messageEvent.data.id);
  }
};
